import {
    Text,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Button,
    ButtonGroup,
    forwardRef,
    useBoolean,
    ModalCloseButton,
    Center,
} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import { createContext, useContext } from 'react'

const PreviewContext = createContext(null)

const PreviewContextProvider = ({ children }) => {
    const ctx = useBoolean(true)
    return (
        <PreviewContext.Provider value={ctx}>
            {children}
        </PreviewContext.Provider>
    )
}
PreviewContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
}

export const useModalContext = () => {
    return useContext(PreviewContext)
}

export const Container =
    /**
     * @param {import('@chakra-ui/react').ModalProps} param0
     * @returns
     */
    ({ children, ...props }) => {
        return (
            <Modal {...props}>
                <ModalOverlay />
                <ModalContent maxW="860px" rounded="none">
                    <PreviewContextProvider> {children}</PreviewContextProvider>
                </ModalContent>
            </Modal>
        )
    }
Container.propTypes = {
    children: PropTypes.node.isRequired,
}

export const Header = () => {
    const [isPC, { on, off }] = useModalContext()
    return (
        <Center as={ModalHeader} fontSize="lg" p={2}>
            <ModalCloseButton />
            <ButtonGroup spacing={1}>
                <ToggleViewButton isActive={isPC} onClick={on}>
                    PC
                </ToggleViewButton>
                <Text as="span" color="tryt.gray-3">
                    /
                </Text>
                <ToggleViewButton isActive={!isPC} onClick={off}>
                    SP
                </ToggleViewButton>
            </ButtonGroup>
        </Center>
    )
}

export const Body = forwardRef((props, ref) => {
    return (
        <ModalBody
            ref={ref}
            w="full"
            p="0 0 var(--chakra-space-6)"
            sx={{
                '.chakra-container.mode-sp': {
                    w: '375px', // iPhoneSE
                },
            }}
            {...props}
        />
    )
})

export const Footer = forwardRef((props, ref) => {
    return <Center as={ModalFooter} p={8} ref={ref} {...props} />
})

export const ToggleViewButton = forwardRef(({ isActive, ...props }, ref) => {
    return (
        <Button
            ref={ref}
            variant="link"
            size="lg"
            type="button"
            minW="auto"
            // colorScheme="primary"
            color={isActive ? 'tryt.primary-1' : 'tryt.gray-3'}
            pointerEvents={isActive ? 'none' : undefined}
            {...props}
        />
    )
})
